<app-header></app-header>

<div class="wrapper">

    <div class="center_body">

        <div class="card">
            <span class="spinner"></span>
            <h1>Processing...</h1>
            <span class="loader"></span>

        </div>

    </div>
</div>
<app-footer></app-footer>